import React, { useEffect, useRef, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { Col, Row, Space } from 'antd'
import { PrimaryButton } from 'Components/button'
import { formatDateTime, getConfigByKey } from 'helpers/format'
import { selectCurrentUser } from 'Store/user/selector'
import { clearEventAction } from 'Store/tax-management/actions'
import EventModal from 'Components/modal/EventModal'
import LoadingView from 'Components/modal/LoadingView'
import { DetailDrawer } from 'Components/common/MainLayout'
import { ConfirmQuestion } from 'Components/modal'
import { ProductsInfo } from '../../Orders/components'
import {
  DeliveryType,
  DocumentConfigKey,
  DocumentDefaultTitle,
  OrderStatus,
  Taxtatus,
} from 'helpers/constanst'
import { TaxDetailReq, UpdateTaxReq } from 'Store/tax-management/types'
import { getTaxDetailAPI, updateTaxAPI } from 'Store/tax-management/api'
import { selectTaxActionEvent, selectTaxDetail, selectTaxDetailEvent } from 'Store/tax-management/selector'
import { InfoItem } from 'Pages/Merchants/components'
import TaxPDF from './TaxPDF'
import { getOrderDetailAPI } from 'Store/orders/api'
import { DetailReq } from 'Store/orders/types'
import { selectDetail, selectDetailEvent } from 'Store/orders/selector'
import ClientInfo from './ClientInfo'
import TaxInfo from './TaxInfo'
import StoreInfo from './StoreInfo'
import TaxSummay from './TaxSummay'
import { selectConfigList } from 'Store/pos/selector'

type Props = ReduxProps & {
  visible: boolean
  onCloseDrawer: () => void
  onSuccess?: () => void
  id: number
  orderNo: string
}

const TaxDetail: React.FunctionComponent<Props> = props => {
  const {
    onCloseDrawer,
    visible,
    currentUser,
    event,
    onSuccess = () => {},
    id,
    detail,
    detailEvent,
    orderDetail,
    orderDetailEvent,
    orderNo,
    configList,
  } = props
  const [rejectDialog, setRejectDialog] = useState(false)
  const [taxPDFtitle, setTaxPDFtitle] = useState(DocumentDefaultTitle.TAX as string)
  const dispatch = useDispatch()
  const printPDF = useRef(null as any)
  const configData = getConfigByKey(configList, DocumentConfigKey.TAX)

  const shippingType = orderDetail?.products[0]?.products[0]?.shipping_detail?.delivery_by || ''

  useEffect(() => {
    if (visible && id !== 0) {
      onGetDetail()
    }
    if (visible && orderNo !== '') {
      onGetOrderDetail()
    }
  }, [visible])

  const onGetDetail = (): void => {
    if (id == 0) return
    const req: TaxDetailReq = {
      id,
    }

    dispatch(getTaxDetailAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || 0))
  }

  const onGetOrderDetail = (): void => {
    if (orderNo == '') return
    const req: DetailReq = {
      order_no: orderNo,
    }
    dispatch(getOrderDetailAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onUpdateStatus = (reason: string): void => {
    const req: UpdateTaxReq = {
      id,
      reason,
    }
    dispatch(updateTaxAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onClickReject = (): void => {
    setRejectDialog(true)
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    clearEvent()
    onGetDetail()
    onSuccess()
    if (rejectDialog) {
      setRejectDialog(false)
    }
  }

  const FooterContent = (
    <Space size="middle" align="baseline">
      <PrimaryButton key={`cancel`} text="ปิด" btnType="Cancel" onClick={onCloseDrawer} />
      {detail?.status === Taxtatus.SUCCESS && (
        <PrimaryButton
          key={`cancel`}
          text="ยกเลิกใบกำกับภาษี"
          btnType="Reject"
          onClick={() => onClickReject()}
        />
      )}
    </Space>
  )

  const ConfirmRejectDailog = (
    <ConfirmQuestion
      title="ยืนยันยกเลิกใบกำกับภาษี?"
      label="เหตุผลที่ยกเลิก"
      placeholder="เช่น ข้อมูลลูกค้าไม่ถูกต้อง..."
      confirmBtnTxt="ยืนยัน"
      isShow={rejectDialog}
      handleOk={(remark: string) => onUpdateStatus(remark)}
      handleCancel={() => setRejectDialog(false)}
      loading={event.IsLoading}
    />
  )

  const renderInfo = (title: string, value: any, span: number = 15) => {
    return <InfoItem title={title} value={value} span={span} />
  }

  const title = (
    <>
      <span>เลขที่ใบกำกับภาษี : {detail?.tax_invoice_no}</span>
    </>
  )

  const renderOrderInfo = () => {
    return (
      <BoxWrapper>
        <BoxTitle>ข้อมูลคำสั่งซื้อ</BoxTitle>
        <Row>
          <Col md={12} xs={24}>
            {renderInfo('เลขที่คำสั่งซื้อ', orderDetail?.order_no)}
            {/* {renderInfo('วันที่สั่งซื้อ', formatDateTime(detail?.order?.created_at || ''))} */}
          </Col>
          <Col md={12} xs={24}>
            {renderInfo('วันที่สั่งซื้อ', formatDateTime(orderDetail?.created_at || ''))}
          </Col>
        </Row>
      </BoxWrapper>
    )
  }

  return (
    <DetailDrawer
      title={title}
      onCloseDrawer={onCloseDrawer}
      visible={visible}
      footer={FooterContent}
      width="70%"
      maskClosable
    >
      <LoadingView isShow={detailEvent.IsLoading || orderDetailEvent?.IsLoading} />
      <EventModal event={[event]} enable={true} successCalback={onEventSuccess} errorCalback={clearEvent} />
      <Row justify="space-between" gutter={16}>
        <Col md={24} xs={24}>
          <TaxInfo
            detail={detail}
            printPDF={printPDF}
            configData={configData}
            onSelectTitle={setTaxPDFtitle}
          />
        </Col>
        <Col md={12} xs={24}>
          <StoreInfo detail={detail} />
        </Col>
        <Col md={12} xs={24}>
          <ClientInfo detail={detail} />
        </Col>
        <Col md={24} xs={24}>
          {renderOrderInfo()}
        </Col>
        <Col md={24} xs={24}>
          <ProductsInfo
            detail={orderDetail}
            orderNo={orderDetail?.order_no || ''}
            merchantId={currentUser?.activeMerchant?.id || 0}
            // isPublicDelivery={false}
            isPublicDelivery={shippingType === DeliveryType.PUBLIC}
            status={OrderStatus.CANCEL}
            selectedGrn={[]}
            setSelectedGrn={() => {}}
            showSummary={false}
            ignoreReturn={false}
          />
        </Col>
        <Col md={12} xs={24}></Col>
        <Col md={8} xs={24}>
          <SummaryInfo>
            <TaxSummay detail={orderDetail} taxData={detail} />
          </SummaryInfo>
        </Col>
      </Row>
      <Row ref={printPDF}>
        <Col span={24}>
          <TaxPDF detail={detail} orderDetail={orderDetail} configData={configData} title={taxPDFtitle} />
        </Col>
      </Row>
      {ConfirmRejectDailog}
    </DetailDrawer>
  )
}

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const SummaryInfo = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  //color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  margin-right: 20px;
  margin-top: 20px;
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectTaxActionEvent(state),
    detail: selectTaxDetail(state),
    detailEvent: selectTaxDetailEvent(state),
    orderDetail: selectDetail(state),
    orderDetailEvent: selectDetailEvent(state),
    configList: selectConfigList(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(TaxDetail)
